import React, { Component } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { CreateEditTruckRouteEnum } from 'Common/FieldEnum';
import { ReactTableColumnProperties } from 'Common/Constants';
import { TrackedCheckbox } from 'Components';

import {
  getItemsByDistributorIds,
  emptySelectedItem,
} from '../../state/createedittruckroute/actions';

class VendorGrid extends Component {
  static propTypes = {
    allVendorsData: PropTypes.array.isRequired,
    loadingAllVendors: PropTypes.bool,
    getItemsByDistributorIds: PropTypes.func.isRequired,
    emptySelectedItem: PropTypes.func.isRequired,
    isNew: PropTypes.bool,
    id: PropTypes.string,
  };
  static defaultProps = {
    loadingAllVendors: false,
    isNew: false,
    id: 0,
  };
  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        const filteredData = [];
        const checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[CreateEditTruckRouteEnum.Id]
            ? obj[CreateEditTruckRouteEnum.Id]
            : obj._original[CreateEditTruckRouteEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length > 0 && checkAllIds.length === dataObjs.length
            )}
            onChange={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: props => {
        const { original } = props;
        return (
          <div style={{ textAlign: 'center' }}>
            <TrackedCheckbox
              initialValue={
                this.props.initialSelectedVendors.indexOf(
                  original[CreateEditTruckRouteEnum.Id]
                ) !== -1
              }
              checked={
                this.props.input.value.indexOf(
                  original[CreateEditTruckRouteEnum.Id]
                ) !== -1
              }
              onChange={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: CreateEditTruckRouteEnum.IsSelected,
      ...ReactTableColumnProperties,
      sortable: false,
      filterable: false,
      width: 150,
    },
    {
      Header: 'Distributor Description',
      visibilityName: 'Distributor Description',
      accessor: CreateEditTruckRouteEnum.Description,
      ...ReactTableColumnProperties,
    },
  ];

  rowInfo = {
    checked: false,
    original: null,
  };

  onFilteredChange = _.debounce(
    filtered => {
      const { getItemsByDistributorIds, id } = this.props;
      getItemsByDistributorIds({
        RouteId: id,
        DistributorIds: this.getFilteredSelectedSites(),
      });
    },
    500,
    { leading: false }
  );

  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const {
      getItemsByDistributorIds,
      input,
      emptySelectedItem,
      isNew,
      id,
    } = this.props;
    const tableRows = [...input.value, ...data];
    const remove = [...tableRows];
    const checkedSites = [];
    _.forEach(dataObjs, obj => {
      const id = obj[CreateEditTruckRouteEnum.Id]
        ? obj[CreateEditTruckRouteEnum.Id]
        : obj._original[CreateEditTruckRouteEnum.Id];
      const index = remove.indexOf(id);
      if (index !== -1) {
        remove.splice(index, 1);
        checkedSites.push(id);
      }
    });
    if (checked) {
      this.props.input.onChange(tableRows);
      getItemsByDistributorIds({ RouteId: id, DistributorIds: checkedSites });
      isNew && emptySelectedItem();
    } else {
      this.props.input.onChange(remove);
      getItemsByDistributorIds({ RouteId: id, DistributorIds: [] });
      isNew && emptySelectedItem();
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const {
      input,
      getItemsByDistributorIds,
      emptySelectedItem,
      isNew,
      id,
    } = this.props;
    if (input && input.value) {
      const formValues = input.value.length > 0 ? [...input.value] : [];
      const index = formValues.indexOf(original[CreateEditTruckRouteEnum.Id]);
      if (checked && index === -1) {
        formValues.push(original[CreateEditTruckRouteEnum.Id]);
      } else if (index > -1) {
        formValues.splice(index, 1);
      }
      this.props.input.onChange(formValues);
      getItemsByDistributorIds({
        RouteId: id,
        DistributorIds: this.getFilteredSelectedSites(formValues),
      });
      isNew && emptySelectedItem();
    }
  };
  getFilteredSelectedSites = formValues => {
    const { allVendorsData, input, reactTableRef } = this.props;
    const checkedSiteOrders = [];
    const dataObjs =
      reactTableRef && reactTableRef.current
        ? reactTableRef.current.getResolvedState()
        : { sortedData: allVendorsData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[CreateEditTruckRouteEnum.Id]
        ? obj[CreateEditTruckRouteEnum.Id]
        : obj._original[CreateEditTruckRouteEnum.Id];
      if (formValues) {
        formValues.indexOf(id) !== -1 && checkedSiteOrders.push(id);
      } else if (input.value.indexOf(id) !== -1) {
        checkedSiteOrders.push(id);
      }
    });
    return checkedSiteOrders;
  };

  render() {
    const { loadingAllVendors, allVendorsData } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          defaultPageSize={20}
          loading={loadingAllVendors}
          data={allVendorsData}
          resizable={true}
          className={'-striped -highlight modalGrid'}
          defaultFilterMethod={caseInsensitiveFilter}
          columns={this.columns}
          noDataText={loadingAllVendors ? '' : 'No sites found'}
          loadingText={loadingAllVendors ? 'Loading...' : ''}
        />
      </Form.Field>
    );
  }
}

const mapDispatchToProps = {
  getItemsByDistributorIds,
  emptySelectedItem,
};

export const VendorGridContainer = connect(
  null,
  mapDispatchToProps
)(VendorGrid);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/createedittruckroute/VendorGridContainer.js